const DFDSession = {
  'session_name': 'Ret\u00FCl Digital Foot Device',
  'image': require(`media/images/sessions/dfd.png`),
  'downloadPdf': false
};

const DSDSession = {
  'session_name': 'Ret\u00FCl Digital Sitbone Device',
  'image': require(`media/images/sessions/dsd.png`),
  'downloadPdf': false
};

const FootSession = {
  'session_name': 'Ret\u00FCl Foot',
  'image': require(`media/images/sessions/foot.png`),
  'downloadPdf': false
};

const LegsSession = {
  'session_name': 'Ret\u00FCl Legs',
  'image': require(`media/images/sessions/legs.png`),
  'downloadPdf': false
};

const MatchSession = {
  'session_name': 'Ret\u00FCl Match',
  'image': require(`media/images/sessions/match.png`),
  'downloadPdf': false
};

const SaddleSession = {
  'session_name': 'Ret\u00FCl Saddle',
  'image': require(`media/images/sessions/saddle.png`),
  'downloadPdf': false
};

const VantageSession = {
  'session_name': 'Ret\u00FCl Fit',
  'image': require(`media/images/sessions/vantage.png`),
  'downloadPdf': true
};

const UnknownSession = {
  'session_name': 'Ret\u00FCl Session',
  'image': '',
  'downloadPdf': false
};

export const DisplaySession = {
  'dfd': DFDSession,
  'dsd': DSDSession,
  'foot': FootSession,
  'legs': LegsSession,
  'match': MatchSession,
  'saddle': SaddleSession,
  'vantage': VantageSession,
  'unknown': UnknownSession,
};



// WEBPACK FOOTER //
// ./src/client/helpers/enums/display-session.js